<div class="confirm-dialog-wrapper" [class.mobile-view]="isMobile">
  <div class="dialog-header">
    <span class="dialog-title">{{data.title || 'Confirmation'}}</span>
  </div>

  <div class="dialog-body">
    <p class="dialog-message">{{data.message}}</p>
  </div>

  <div class="dialog-footer">
    <button class="action-btn cancel-btn" (click)="onNoClick()">No</button>
    <button class="action-btn confirm-btn" (click)="onYesClick()">Yes</button>
  </div>
</div>